/**
 * Formata valor para moeda brasileira
 */
export const formatCurrency = (value, showSign = false) => {
  if (value === null || value === undefined) return 'R$ 0,00';
  
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  const formatted = formatter.format(Math.abs(value));
  
  if (showSign && value !== 0) {
    return value > 0 ? `+${formatted}` : `-${formatted}`;
  }
  
  return value < 0 ? `-${formatted}` : formatted;
};

/**
 * Formata data para exibição
 */
export const formatDate = (date, format = 'short') => {
  if (!date) return '';
  
  // Se já é um datetime ISO, usa diretamente; senão força timezone local
  const d = String(date).includes('T') ? new Date(date) : new Date(date + 'T00:00:00');

  const formats = {
    short: { day: '2-digit', month: '2-digit', year: 'numeric' },
    medium: { day: '2-digit', month: 'short', year: 'numeric' },
    long: { day: '2-digit', month: 'long', year: 'numeric' },
    full: { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' },
    dayMonth: { day: '2-digit', month: 'short' },
    monthYear: { month: 'long', year: 'numeric' },
  };

  return d.toLocaleDateString('pt-BR', formats[format] || formats.short);
};

/**
 * Formata data e hora
 */
export const formatDateTime = (date) => {
  if (!date) return '';
  
  const d = new Date(date);
  
  return d.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

/**
 * Formata número com separador de milhar
 */
export const formatNumber = (value, decimals = 0) => {
  if (value === null || value === undefined) return '0';
  
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
};

/**
 * Formata porcentagem
 */
export const formatPercentage = (value, decimals = 1) => {
  if (value === null || value === undefined) return '0%';
  
  return `${formatNumber(value, decimals)}%`;
};

/**
 * Trunca texto
 */
export const truncate = (text, length = 50) => {
  if (!text) return '';
  if (text.length <= length) return text;
  return `${text.substring(0, length)}...`;
};

/**
 * Capitaliza primeira letra
 */
export const capitalize = (text) => {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

/**
 * Formata CPF
 */
export const formatCPF = (cpf) => {
  if (!cpf) return '';
  const cleaned = cpf.replace(/\D/g, '');
  return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

/**
 * Formata telefone
 */
export const formatPhone = (phone) => {
  if (!phone) return '';
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 11) {
    return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }
  return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
};

/**
 * Retorna nome do dia da semana
 */
export const getDayOfWeek = (date) => {
  const days = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
  const d = new Date(date + 'T00:00:00');
  return days[d.getDay()];
};

/**
 * Retorna nome abreviado do dia da semana
 */
export const getDayOfWeekShort = (date) => {
  const days = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
  const d = new Date(date + 'T00:00:00');
  return days[d.getDay()];
};

export default {
  formatCurrency,
  formatDate,
  formatDateTime,
  formatNumber,
  formatPercentage,
  truncate,
  capitalize,
  formatCPF,
  formatPhone,
  getDayOfWeek,
  getDayOfWeekShort,
};
